import { render, staticRenderFns } from "./changeOptionManage.vue?vue&type=template&id=28c20f7b&scoped=true&"
import script from "./changeOptionManage.vue?vue&type=script&lang=js&"
export * from "./changeOptionManage.vue?vue&type=script&lang=js&"
import style0 from "./changeOptionManage.vue?vue&type=style&index=0&id=28c20f7b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c20f7b",
  null
  
)

export default component.exports